export default (props) => ({
  __typename: 'Paragraph',
  ...props.text && {
    text: props.text,
  },
  inline: false,
})
